import * as React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core';

// ui
import { ModalMenuUI } from '../../../Modal/ModalMenuUI';
import ReviewLinkSmallOverviewItemUI from '../Subcomponents/ReviewLinkSmallOverviewItemUI';
import { iconAdd } from '../../../icons/GeneralSVG';
import { Divider } from '../../../Surface/Divider';
import InteractableSurface from '../../../Surface/InteractableSurface';

/* Import Interface */
import Cube3Button from '../../../Buttons/Cube3Button';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    sharedLinkContainer: {
      padding: '8px 16px'
    },
    newLinkButton: {
      backgroundColor: 'unset',
      '&:hover': {
        backgroundColor: 'unset'
      }
    },
    newLinkContainer: {
      display: 'flex',
      padding: '8px 16px',
      marginTop: 20,
      marginBottom: 20,
      alignItems: 'center'
    }
  })
);
export interface ReviewLinkUIProps {
  classes?: { [key: string]: string };
  created_at: string;
  expires: boolean;
  expires_at: string;
  expired: boolean;
  email_addresses: string[];
  users: { email_address: string; profile_picture?: string }[];
  display_name?: string;
  node?: string;
  id?: string;
  onClick: () => void;
}
interface Properties {
  loading?: boolean;
  onClickNew?: () => void;
  onCloseEvent: () => void;
  reviewLinks: ReviewLinkUIProps[];
}

const ReviewLinkOverviewModalUI: React.FC<
  React.PropsWithChildren<Properties>
> = (props) => {
  const { onClickNew, onCloseEvent, reviewLinks = [], loading = false } = props;

  const classes = useStyles();

  return (
    <ModalMenuUI
      title={'Links'}
      onCloseEvent={() => onCloseEvent()}
      loading={loading}
      footerRightComponent={
        <>
          <Cube3Button
            text={'Done'}
            colorVariant={'filled1'}
            onClick={() => onCloseEvent()}
          />
        </>
      }
    >
      <InteractableSurface
        classes={{ root: classes.newLinkContainer }}
        onClickEvent={() => onClickNew()}
        highlightOnHover={true}
        surfaceProps={{
          background: 'transparent',
          corners: 'rounded'
        }}
      >
        <Cube3Button
          text="New review link"
          pathLeftSvg={iconAdd}
          colorVariant="ghost1"
          disableHover={true}
          data-cy="newLinkButton"
          className={classes.newLinkButton}
          marginCollapse={'left'}
        />
      </InteractableSurface>

      <Divider />

      {props.children}

      {reviewLinks.map((item, index) => {
        return (
          <ReviewLinkSmallOverviewItemUI
            key={index}
            classes={{ container: classes.sharedLinkContainer }}
            created_at={item.created_at}
            email_addresses={item.email_addresses}
            users={item.users}
            expires_at={item.expires_at}
            expires={item.expires}
            expired={item.expired}
            onClick={() => item.onClick()}
          />
        );
      })}
    </ModalMenuUI>
  );
};

export default ReviewLinkOverviewModalUI;
